export const FILE_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // 'text/plain',
  // 'application/vnd.ms-excel',
  // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // 'application/vnd.ms-powerpoint',
  // 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
